<template>
  <div class="container">
    <div class="row justify-content-center">
      <table class="table table-borderless col-8 text-left">
        <thead>
        <tr>
          <th colspan="2" class=""><h3>Factuuroverzicht</h3></th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td colspan="2" class="text-left font-weight-bold">Algemeen</td>
        </tr>
        <tr>
          <td>Status</td>
          <td class="font-weight-bold">
            <span v-if="selectedInvoice.status === 'CREATED'" style="color: #a3101d;">AANGEMAAKT</span>
            <span v-else style="color: #287c37;">VOLTOOID</span>
          </td>
        </tr>
        <tr>
          <td>Documentnummer</td>
          <td>{{ selectedInvoice.invoiceNr }}</td>
        </tr>
        <tr>
          <td>Documentdatum</td>
          <td>{{ selectedInvoice.invoiceDate }}</td>
        </tr>
        <tr>
          <td>BTW Klant</td>
          <td>{{ selectedInvoice.customerBillingDto.vat }}</td>
        </tr>
        <tr>
          <td>Contact</td>
          <td>{{ selectedInvoice.contactMail }}</td>
        </tr>
        <tr>
          <td>Externe Referentie</td>
          <td>{{ selectedInvoice.externalReference }}</td>
        </tr>
        <tr>
          <td>Interne Referentie</td>
          <td>{{ selectedInvoice.internalReference }}</td>
        </tr>
        <tr>
          <td>Disclaimer</td>
          <td>{{ selectedInvoice.disclaimer }}</td>
        </tr>
        <tr>
          <td colspan="2" class="text-left font-weight-bold">Klantgegevens</td>
        </tr>
        <tr>
          <td>Aangeschrevene</td>
          <td>
            {{ selectedInvoice.customerBillingDto.financialSupervisorReference }}
          </td>
        </tr>
        <tr>
          <td>Organisatienaam</td>
          <td>{{ selectedInvoice.customerBillingDto.organisationName }}</td>
        </tr>
        <tr>
          <td>E-mail(s) voor facturatie</td>
          <td>
            <a v-for="confirmedEmailDto in selectedInvoice.confirmedEmailDtos" :style="setColor(confirmedEmailDto.confirmed)" :key="confirmedEmailDto.emailAddress">{{confirmedEmailDto.emailAddress}}, </a>
          </td>
        </tr>
        <tr>
          <td>Adres</td>
          <td>
            {{ selectedInvoice.customerBillingDto.street }} {{ selectedInvoice.customerBillingDto.houseNumber }}
            <br/>
            {{ selectedInvoice.customerBillingDto.postalCode }} {{ selectedInvoice.customerBillingDto.city }}
            <br/>
            {{ selectedInvoice.customerBillingDto.country }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="text-left font-weight-bold">Tarief</td>
        </tr>
        <tr>
          <td>Subtotaal</td>
          <td>€{{ selectedInvoice.totalVATExcluded }}</td>
        </tr>
        <tr>
          <td>BTW</td>
          <td>{{ selectedInvoice.vatpercentage }}%</td>
        </tr>
        <tr>
          <td>Totaal (incl. BTW)</td>
          <td>€{{ selectedInvoice.totalVATIncluded }}</td>
        </tr>
        <tr>
          <td>Betalingsvoorwaarden</td>
          <td>
            {{ selectedInvoice.customerBillingDto.paymentTerm }}
            dagen na factuurdatum
          </td>
        </tr>
        <tr v-if="selectedInvoice.latestSentDate">
          <td colspan="1" class="text-left font-weight-bold">E-mail laatst verzonden op:</td>
          <td>{{ selectedInvoice.latestSentDate | toDayMonthYearHoursMinutesSeconds }}</td>
        </tr>
        </tbody>
        <tr>
          <td>Timesheet en factuur in één pdf</td>
          <td>{{selectedInvoice.customerBillingDto.wantsConcatenatedDocuments}}</td>
        </tr>
        <tr>
          <td>Factuur versturen naar Peppol</td>
          <td>{{selectedInvoice.customerBillingDto.peppolEndPointDto.active}}</td>
        </tr>
        <tr>
          <td>Peppol nummer</td>
          <td>{{selectedInvoice.customerBillingDto.peppolEndPointDto.number}}</td>
        </tr>
        <tr>
          <td>Peppol nummer type</td>
          <td>{{selectedInvoice.customerBillingDto.peppolEndPointDto.type}}</td>
        </tr>
      </table>
    </div>

    <div class="row justify-content-center mt-3">
      <table class="table table-striped col-6 text-left">
        <thead>
        <tr>
          <td colspan="6" class="text-center font-weight-bold">Vrije kosten</td>
        </tr>
        <tr class="text-center">
          <td>Omschrijving</td>
          <td>Aantal</td>
          <td>Eenheden</td>
          <td>Kost</td>
          <td>Type kost</td>
        </tr>
        </thead>
        <tbody>
        <tr class="text-center" v-for="(cost, index) in selectedInvoice.freeCosts" :key="index">
          <td>{{ cost.description }}</td>
          <td>{{ cost.amount }}</td>
          <td>{{ cost.units }}</td>
          <td>€{{ cost.cost }}</td>
          <td>{{ cost.accountingCost.name }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="btn-group">
      <button v-if="selectedInvoice.status === 'CREATED'"
          type="button"
          style="width: 180px;"
          class="btn-basic btn-outline-pulse mb-3 mr-2"
          @click="finishInvoice()">
        Factureren
      </button>
      <button v-if="selectedInvoice.status === 'CONFIRMED'|| selectedInvoice.status ==='CREDIT_NOTED'"
          type="button"
          style="width: 180px;"
          class="btn-basic btn-outline-pulse mb-3 mr-2"
          :disabled="!activateMailButton()"
          @click="mailInvoice()">
        Mailen
      </button>
      <button v-if="selectedInvoice.status === 'MAILED'"
          type="button"
          style="width: 180px;"
          class="btn-outline-pulse btn-red mb-3 mr-2"
          @click="mailInvoice()">
        Nog eens Mailen
      </button>
      <button
          type="button"
          style="width: 180px;"
          class="btn-basic btn-outline-pulse mb-3 mr-2"
          :disabled="(selectedInvoice.status === 'CONFIRMED'|| selectedInvoice.status ==='CREDIT_NOTED')||selectedInvoice.status === 'MAILED'"
          @click="editInvoice()">
        Bewerken
      </button>
      <button
          type="button"
          style="width: 180px;"
          v-if="isDownloading" class="btn-basic btn-fill-pulse-dark mb-3"
          disabled>Downloading
      </button>
      <button
          type="button"
          style="width: 180px;"
          v-else class="btn-basic btn-outline-pulse-dark mb-3 mr-2"
          @click="downloadInvoice()">
        Download PDF
      </button>
      <CreditNoteModal />
      <button
          type="button"
          style="width: 180px;"
          v-if="isDownloadingCreditNote" class="btn-basic btn-dark mb-3 mr2"
          disabled>Downloading
      </button>

    </div>

    <UpdateInvoiceModal ref="updateInvoice"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import UpdateInvoiceModal from "@/components/modals/UpdateInvoiceModal";
import {VoerroModal} from "@voerro/vue-modal";
import CreditNoteModal from "@/components/modals/CreditNoteModal.vue";

export default {
    name: "AdminInvoiceDetail",
    components: {
      CreditNoteModal,
      UpdateInvoiceModal
    },
    data: () => ({
      isDownloading: false,
      isDownloadingCreditNote: false
    }),
    computed: {
        ...mapGetters({
            selectedInvoice: "administrationInvoice/selectedInvoice"
        }),
      setColor() {
        return confirmed => {
          if(confirmed === true) {
            this.isColor = 'green';
          } else {
            this.isColor = 'red';
          }
          return { color: this.isColor };
        };
      },
    },
    methods: {
      ...mapActions("administrationInvoice", ["downloadSelectedInvoicePDF", "updateInvoiceStatus", "fetchInvoiceById","downloadSelectedCreditNotePDF","createCreditNote","mailInvoiceById"]),
      downloadInvoice() {
        this.isDownloading = true;
        this.downloadSelectedInvoicePDF(this.selectedInvoice.id)
            .then(() => this.isDownloading = false)
            .catch(() => this.isDownloading = false);
      },
      activateMailButton() {
        let activate = true;
        for (const element of this.selectedInvoice.confirmedEmailDtos) {
          if (element.confirmed  === false) {
            activate = false;
          }
        }
        return activate;
      },
      editInvoice() {
        this.fetchInvoiceById(this.selectedInvoice.id);
        VoerroModal.show('updateInvoice');
      },
      finishInvoice() {
        this.updateInvoiceStatus('CONFIRMED');
      },
      mailInvoice(){
        this.mailInvoiceById(this.selectedInvoice.id);
      }
    }
};
</script>

<style scoped>
table th {
  width: 50% !important;
}
</style>